<template>
    <v-container fluid>
        <v-toolbar flat color="#FAFAFA" >
            <v-btn icon outline color="black"  to="/obras">
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title >{{toolbarName}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="green" dark @click="$refs.obra_info_ref.salvar()">salvar</v-btn>
        </v-toolbar>
        <template>
            <obra_info :obra_id="item_id" ref="obra_info_ref" />
        </template>
    </v-container>
</template>
<script>
import obra_info from "../../components/obras/obra_info";

export default {
    components: {
        obra_info
    },
    data() {
        return {
            item_id: 0
        };
    },
    created() {
        this.item_id = this.$route.params.id;
    },
    computed:{
      toolbarName: function(){
        if(this.item_id){
          return 'Editar Obra';
        }

        return 'Nova Obra';
      }
    }
};
</script>
